<template>
  <modal
    :header-text="headerText"
    button-text="Ок"
    :not-active="isLoading"
    :class="$style.modal"
    @action="add"
    @close="close"
  >
    <loader v-if="isLoading" />
    <div v-else-if="computer">
      <div
        v-if="isMessegeType"
        :class="$style.inputContainer"
      >
        <label :class="$style.label">{{ $t('tasks.messageText') }} {{ computer.value.name }}</label>
        <input
          v-model="text"
          type="text"
          :class="$style.input"
        >
      </div>
      <div
        v-else
        :class="$style.inputContainer"
      >
        <label :class="$style.label">{{ $t('tasks.printPermissionTime') }} {{ computer.value.name }}</label>
        <input
          v-model="minute"
          type="number"
          min="0"
          :class="$style.input"
        >
      </div>
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/common/modal/tasks-modal.vue';
  import Loader from '@/components/common/blocks/loader.vue';

  export default {
    components: { Modal, Loader },
    props: ['computer', 'type', 'isLoading'],
    data: () => ({
      text: '',
      minute: 1,
    }),
    computed: {
      isMessegeType() {
        return this.type === '11';
      },
      headerText() {
        return this.isMessegeType ? this.$t('tasks.sendMessage') : this.$t('tasks.allowPrintConfidentialDocs');
      },
    },
    methods: {
      close() {
        this.$emit('close');
      },
      add() {
        const payload = this.isMessegeType ? this.text : this.minute * 60;
        this.$emit('add', payload, this.type);
      },
    },
  };
</script>

<style lang="scss" module>
  .input {
    margin: 5px;
    width: 60%;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    height: 30px;
  }
  .inputContainer {
    font-size: 13px;
    margin: 5px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .label {
    width: 40%;
    line-height: normal;
  }
  .alert {
    padding: 5px;
    color: $red;
  }
</style>
